import { useState, useEffect } from 'react';import './Contact.css';
import emailjs from '@emailjs/browser';

const INTERESTS = [
  'Admin Portal (Recruiter & Hiring)',
  'Candidate Portal (Job seekers)',
  'Full VERDICT Platform',
  'Assessment Engine Only',
  'Enterprise / Custom Package',
  'Request a Live Demo',
];

export default function Contact() {
  const [form, setForm] = useState({
    name: '', email: '', phone: '', organization: '', role: '', interest: '', message: '',
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  emailjs.init('Y2SpiZe-UsLY-Lmxe');
}, []);

  const validate = () => {
    const e = {};
    if (!form.name.trim())         e.name = 'Full name is required';
    if (!form.email.trim())        e.email = 'Work email is required';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Enter a valid email address';
    if (!form.phone.trim())        e.phone = 'Phone number is required';
    if (!form.organization.trim()) e.organization = 'Organisation name is required';
    return e;
  };

  const handleChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
    if (errors[e.target.name]) setErrors(er => ({ ...er, [e.target.name]: '' }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const errs = validate();

  if (Object.keys(errs).length) {
    setErrors(errs);
    return;
  }

  setLoading(true);

  const templateParams = {
    product_name: 'VERDICT',

    full_name: form.name,
    email: form.email,

    company: form.organization,

    role: form.role || 'Not Provided',

    // Reusing common template fields
    size: form.phone || 'Not Provided',

    interest: form.interest || 'Not Provided',

    message: `
Phone Number: ${form.phone}

Hiring Challenges:
${form.message || 'No additional comments'}
    `
  };

  try {
    // Admin notification email
    await emailjs.send(
      'service_ioywtjd',
      'template_exkeoo4',
      templateParams
    );

    // User confirmation email
    await emailjs.send(
      'service_ioywtjd',
      'template_09t0zzd',
      templateParams
    );

    setSubmitted(true);

    setForm({
  name: '',
  email: '',
  phone: '',
  organization: '',
  role: '',
  interest: '',
  message: '',
});

  } catch (error) {
    console.error('EmailJS Error:', error);
    alert('Unable to send email. Please try again.');
  } finally {
    setLoading(false);
  }
};

  return (
    <section id="contact" className="section-divider">
      <div className="section-wrap">
        <div className="contact-grid">

          {/* Left info */}
          <div className="contact-info">
            <span className="eyebrow">Get in Touch</span>
            <h2 className="sec-title" style={{ fontSize: 'clamp(1.6rem, 3vw, 2.4rem)' }}>
              Let's talk about your hiring needs.
            </h2>
            <p style={{ color: '#9b8ab8', lineHeight: 1.8, marginBottom: '2.5rem', fontSize: '.95rem' }}>
              Whether you're a recruiter looking to scale hiring, an HR leader needing
              assessment tools, or a candidate-first company — VERDICT is built for you.
              Fill in your details and our team responds within one business day.
            </p>

            <div className="contact-details">
              {[
                { icon: '📧', label: 'Email us', val: 'support@aiprus.com',     href: 'mailto:support@aiprus.com' },
                { icon: '📞', label: 'Call us',  val: '+91-842-000-6452',        href: 'tel:+918420006452' },
                { icon: '🌐', label: 'Website',  val: 'www.aiprus.com',          href: 'https://www.aiprus.com' },
              ].map(d => (
                <a key={d.label} href={d.href} className="contact-detail" target={d.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer">
                  <div className="contact-detail__icon">{d.icon}</div>
                  <div>
                    <div className="contact-detail__label">{d.label}</div>
                    <div className="contact-detail__val">{d.val}</div>
                  </div>
                </a>
              ))}
            </div>

            {/* What you get */}
            <div className="contact-what">
              <p className="contact-what__title">What's included in your demo</p>
              {[
                'Full Admin Portal walkthrough',
                'Live assessment creation demo',
                'Candidate portal experience',
                'Analytics & dashboard preview',
                'Pricing tailored to your team size',
                'Q&A with our product team',
              ].map(i => (
                <div key={i} className="contact-what__item">
                  <span className="contact-what__check">✓</span>{i}
                </div>
              ))}
            </div>
          </div>

          {/* Right form */}
          <div className="contact-form-wrap">
            {submitted ? (
              <div className="contact-success">
                <div className="success-anim">
                  <div className="success-ring" />
                  <div className="success-icon-inner">✓</div>
                </div>
                <h3>Thank you, {form.name.split(' ')[0]}!</h3>
                <p>
                  We've received your request from <strong>{form.organization}</strong>.<br />
                  Our team will reach out to <strong>{form.email}</strong> within one business day.
                </p>
                <button className="btn-purple" style={{ marginTop: '1.5rem' }} onClick={() => setSubmitted(false)}>
                  Submit another enquiry
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit} noValidate>
                <h3 className="contact-form__title">Request a Demo</h3>
                <p className="contact-form__sub">
                  Tell us about your team and we'll tailor the demo to your exact use case.
                </p>

                <div className="form-row">
                  <div className={`ff ${errors.name ? 'ff--err' : ''}`}>
                    <label>Full Name <span>*</span></label>
                    <input name="name" type="text" placeholder="Prakhar Agarwal" value={form.name} onChange={handleChange} />
                    {errors.name && <span className="ff-err">{errors.name}</span>}
                  </div>
                  <div className={`ff ${errors.email ? 'ff--err' : ''}`}>
                    <label>Work Email <span>*</span></label>
                    <input name="email" type="email" placeholder="you@company.com" value={form.email} onChange={handleChange} />
                    {errors.email && <span className="ff-err">{errors.email}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className={`ff ${errors.phone ? 'ff--err' : ''}`}>
                    <label>Phone Number <span>*</span></label>
                    <input name="phone" type="tel" placeholder="+91 98765 43210" value={form.phone} onChange={handleChange} />
                    {errors.phone && <span className="ff-err">{errors.phone}</span>}
                  </div>
                  <div className={`ff ${errors.organization ? 'ff--err' : ''}`}>
                    <label>Organisation <span>*</span></label>
                    <input name="organization" type="text" placeholder="Aiprus Software Pvt Ltd" value={form.organization} onChange={handleChange} />
                    {errors.organization && <span className="ff-err">{errors.organization}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="ff">
                    <label>Your Role</label>
                    <select name="role" value={form.role} onChange={handleChange}>
                      <option value="">Select your role</option>
                      <option>HR Manager</option>
                      <option>Hiring Manager</option>
                      <option>Recruiter</option>
                      <option>Talent Acquisition Lead</option>
                      <option>CHRO / VP People</option>
                      <option>Founder / CEO</option>
                      <option>Other</option>
                    </select>
                  </div>
                  <div className="ff">
                    <label>Area of Interest</label>
                    <select name="interest" value={form.interest} onChange={handleChange}>
                      <option value="">What are you looking for?</option>
                      {INTERESTS.map(i => <option key={i}>{i}</option>)}
                    </select>
                  </div>
                </div>

                <div className="ff">
                  <label>Tell us about your hiring challenges</label>
                  <textarea
                    name="message" rows={4}
                    placeholder="E.g. We hire 50+ engineers per quarter and need a better way to assess candidates at scale..."
                    value={form.message} onChange={handleChange}
                  />
                </div>

                <button type="submit" className="btn-purple contact-submit" disabled={loading}>
                  {loading ? (
                    <span className="loading-dots"><span /><span /><span /></span>
                  ) : 'Send Enquiry →'}
                </button>

                <p className="form-privacy">
                  🔒 Your information is secure. We never share your details with third parties.
                  By submitting, you agree to our <a href="#!" onClick={e => e.preventDefault()}>Privacy Policy</a>.
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
